const STORAGE_KEY = 'sa_pending_verification_email';

export function setPendingVerificationEmail(email: string): void {
  sessionStorage.setItem(STORAGE_KEY, email.trim().toLowerCase());
}

export function getPendingVerificationEmail(): string | null {
  return sessionStorage.getItem(STORAGE_KEY);
}

export function clearPendingVerificationEmail(): void {
  sessionStorage.removeItem(STORAGE_KEY);
}
